﻿//Based on Pikulin.PW ResizableHeight Plugin – https://github.com/pikulinpw/ckeditor5-resizableheight

import { Plugin } from 'ckeditor5';

import { debounce } from '../utils';

function sleep(time) {
    return new Promise((resolve, reject) => {
        window.setTimeout(() => resolve(), time);
    });
}

export default class Sizing extends Plugin {
    static get pluginName() { return "Sizing" };

    init() {
        const editor = this.editor;
        const editorWrapper = document.createElement('div');
        const contentWrapper = document.createElement('div');

        this.editor.on('ready', async () => {
            const height = editor.sourceElement?.getAttribute('data-height') || editor.config.get('Sizing.height'),
                width = editor.sourceElement?.getAttribute('data-width') || editor.config.get('Sizing.width'),
                resize = editor.config.get('Sizing.resize');

            editorWrapper.classList.add('ck', 'ck-reset', 'ck-sizing-wrapper');
            contentWrapper.classList.add('ck', 'ck-reset', 'ck-content-sizing-wrapper');

            if (resize === undefined || resize === true) {
                contentWrapper.classList.add('ck-content-sizing-wrapper__resizable');
                
                if (window.safari !== undefined) {
                    contentWrapper.classList.add('ck-sizing-safari');
                }
                
                const minHeight = editor.sourceElement?.getAttribute('data-minheight') || editor.config.get('Sizing.minHeight'),
                    maxHeight = editor.sourceElement?.getAttribute('data-maxheight') || editor.config.get('Sizing.maxHeight');

                if (minHeight === undefined || maxHeight === undefined || minHeight !== maxHeight) {
                    var fireResize = debounce(() => {
                        editor.fire('resize');
                    }, 250);

                    const observer = new ResizeObserver(() => {
                        fireResize();
                    });

                    observer.observe(contentWrapper);
                }

                if (minHeight) {
                    contentWrapper.style.minHeight = minHeight;
                }
                if (maxHeight) {
                    contentWrapper.style.maxHeight = maxHeight;
                }
            }


            if (height) {
                contentWrapper.style.height = height;
            }

            if (width) {
                editorWrapper.style.width = width;
            }

            let toWrap = editor.ui.view.element;
            // wait for editor element to be placed in DOM before wrapping
            // can occur when initializing without sourceElement
            while (toWrap.parentNode === null) {
                await sleep(50);
            }

            toWrap.parentNode.insertBefore(editorWrapper, toWrap);
            editorWrapper.appendChild(toWrap);

            toWrap = editor.ui.view.editable.element.parentNode;
            toWrap.parentNode.insertBefore(contentWrapper, toWrap);
            contentWrapper.appendChild(toWrap);
        });

        this.editor.on('destroy', () => {
            editorWrapper.remove();
        });
    }
}